import MobileDetect from 'mobile-detect'

$(document).ready(() => {
    const md = new MobileDetect(window.navigator.userAgent)

    if (!md.mobile()) {
        // Overlay Blocks
        $('.image-block-container').each((index, obj) => {
            $(obj).find('.image-block').on('mouseenter', (e) => {
                e.preventDefault()
                $(obj).find('.overlay').toggleClass('hide')
                $(obj).children('.twg-spirit-link').hide()
            })
            $(obj).find('.image-block').on('mouseleave', (e) => {
                e.preventDefault()
                $(obj).find('.overlay').toggleClass('hide')
                $(obj).children('.twg-spirit-link').show()
            })
        })
    } 
    if (md.mobile()) {
        // Overlay Blocks
        $('.image-block-container').each((index, obj) => {
            $(obj).find('.image-block').on('click', (e) => {
                e.preventDefault()
                $(obj).find('.overlay').toggleClass('hide')
            })
        })
    }


    // Menu 
    // $('#menu-item-67').on('mouseenter', (e) => {
    //     e.preventDefault()
    //     $('#menu-item-67 .sub-menu').toggleClass('show');
    // })
    // $('#menu-item-67').on('mouseleave', (e) => {
    //     e.preventDefault()
    //     $('#menu-item-67 .sub-menu').toggleClass('show');
    // })
})